import React from 'react';
import loadable from '@loadable/component';

import CategorizerStub from './components/Categorizer/CategorizerStub';

export const loadFiltersModule = /* #__LOADABLE__ */ () =>
    import(/* webpackChunkName: "filters-module" */ './index');

/* eslint-disable react/display-name */

export const AsyncCategorizer = loadable(loadFiltersModule, {
    resolveComponent: ({ default: filters }) => filters.components.Categorizer, // TODO check if p-min-delay 1000 needed
});

export const AsyncMobileFilters = loadable(loadFiltersModule, {
    resolveComponent: ({ default: filters }) =>
        filters.components.MobileFilters,
    fallback: <CategorizerStub />,
});

export const AsyncSportsNavigation = loadable(loadFiltersModule, {
    resolveComponent: ({ default: filters }) =>
        filters.components.SportsNavigation,
});

export const AsyncMobileFiltersCtxComponent = loadable(loadFiltersModule, {
    resolveComponent: ({ default: filters }) =>
        filters.components.MobileFiltersCtxProvider,
});
